export let unableToLoadPlacesSettingsTitle = "pzwzjd";
export let unableToLoadPlacesSettings = "jhaHrd";
export let unableToLoadPlacesSettingsButtonLabel = "nRc_Ie";
export default {unableToLoadPlacesSettingsTitle,unableToLoadPlacesSettings,unableToLoadPlacesSettingsButtonLabel};